import RelatedDataSection from './RelatedDataSection';

export default RelatedDataSection;
